module.exports = __webpack_public_path__ + "static/media/rolocule-logo.257e7a64.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/rolocule-logo.png
// module id = 479
// module chunks = 0